import React from "react";

const MemberPage = () => {
  return <main>MemberPage</main>;
};

export default MemberPage;
